import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { BackgroundPage, Title, Mouse } from "./styles"
import Logo from '../Logo'
const Background = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "background-small.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <BackgroundPage image={data.placeholderImage.childImageSharp.fluid}>
      {/* <Title>LIBERTI</Title> */}
      <Logo fill="#FFF"/>
      <Mouse/>
    </BackgroundPage>
  )
}

export default Background
